import React from 'react';
import { createFromIconfontCN } from '@ant-design/icons';

const Icon = createFromIconfontCN({
  // scriptUrl: '//at.alicdn.com/t/c/font_3208704_zzbfdxw8quf.js', // 在 iconfont.cn 上生成
  // @ts-ignore
  scriptUrl: import('@/pages/home/assets/iconfont/iconfont.js'), // 在 iconfont.cn 上生成
});

interface IconType {
  type: string;
  className?: string;
  style?: React.CSSProperties;
  color?: string;
  onClick?: (e: React.SyntheticEvent<HTMLSpanElement>) => void;
}

export default function SvgIcon(props: IconType) {
  const { type, className, style, color, onClick } = props;
  return (
    <Icon
      type={`tea-icon-${type}`}
      className={`svg-icon${className ? ` ${className}` : ''}`}
      style={style}
      color={color}
      onClick={onClick}
    />
  );
}
